"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _typography = _interopRequireDefault(require("../typography"));

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var styles = "@font-face {\n  font-family: 'OpenSansRegular';\n  src: url(\"../assets/font/OpenSans-latin-normal.woff2\") format(\"woff2\"); }\n\n.bds-progress-bar-parent-container {\n  display: flex;\n  width: max-content;\n  align-items: center; }\n  .bds-progress-bar-parent-container .bds-progress-bar-container {\n    display: flex;\n    align-items: center; }\n    .bds-progress-bar-parent-container .bds-progress-bar-container .bds-progress-bar-leading {\n      display: flex;\n      height: inherit;\n      background-color: #24a148; }\n    .bds-progress-bar-parent-container .bds-progress-bar-container .bds-progress-bar-trailing {\n      display: flex;\n      height: inherit;\n      background-color: #f4f4f4; }\n  .bds-progress-bar-parent-container .bds-progress-bar-value {\n    display: flex;\n    margin-left: 0.5rem; }\n";
  var fileName = "compone_ProgressBar";
  var element = document.querySelector("style[data-sass-component='compone_ProgressBar']");

  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();

var ProgressBar = function ProgressBar(_ref) {
  var progressPercentage = _ref.progressPercentage,
      displayValue = _ref.displayValue,
      width = _ref.width,
      height = _ref.height;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.parentContainer
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.container,
    style: {
      width: width,
      height: height
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.leading,
    style: {
      width: "".concat(progressPercentage / 100 * width, "px")
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.trailing,
    style: {
      width: "".concat((100 - progressPercentage) / 100 * width, "px")
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.value
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label1"
  }, displayValue))));
};

var _default = ProgressBar;
exports.default = _default;
ProgressBar.propTypes = {
  progressPercentage: _propTypes.default.number,
  width: _propTypes.default.number,
  displayValue: _propTypes.default.string
};